var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAutopay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1214_7240)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 19C29 16.2386 26.7614 14 24 14C21.2386 14 19 16.2386 19 19C19 22.7614 22 23.5 24 24C26 24.5 29 25.2386 29 29C29 31.7614 26.7614 34 24 34C21.2386 34 19 31.7614 19 29",
    stroke: "#0F2342",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0002 24.0002C43.0002 28.8628 41.1452 33.7253 37.4352 37.4353C30.0153 44.8552 17.9851 44.8552 10.5652 37.4353L10.5652 44.0002M5.0002 24.0002C5.0002 19.1377 6.85519 14.2752 10.5652 10.5652C17.9851 3.14524 30.0153 3.14524 37.4352 10.5652L37.4352 5.00023",
    stroke: "#0F2342",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 38L24 24L24 10",
    stroke: "#0F2342",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1214_7240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAutopay);
export default __webpack_public_path__ + "static/media/icon-autopay.180fcc9cd2b707e9044adab20c4a62a2.svg";
export { ForwardRef as ReactComponent };